<div class="d-inline-block" style="vertical-align: middle">
  <div class="d-flex align-items-center gap-2 line-height-20">
    <i
      class="icon ic-asic-black-white-20 cursor-default"
      tooltipClass="tooltip-info"
      placement="top"
      container="body"
      [ngbTooltip]="model?.record?.nonAsic ? 'non-ASIC' : 'ASIC'"
      [class]="{
        'bg-gray-600': model?.record?.nonAsic,
        'bg-asic-blue': !model?.record?.nonAsic
      }"
    ></i>

    <i [class]="'icon ' + model?.iconClass"></i>

    <ul class="flex-grow-1 list-unstyled m-0 p-0">
      @for (holderLine of holdersLines; track holderLine) {
        @if (!pendingButtonState) {
          <li class="shareholder-name-line">
            <div class="name">{{ holderLine.previousName || holderLine.name }}</div>

            @if (!holderLine.isIndividual) {
              <div class="color-gray-700 line-height-12">{{ (holderLine.entityNumber | acn) ?? '-' }}</div>
            }
          </li>
        } @else {
          <li
            class="shareholder-name-line"
            [class]="{ different: holderLine.areNamesDifferent }"
          >
            <div
              class="name hide-empty"
              [class]="{ 'line-through': holderLine.isLineThrough, red: holderLine.isNameRed }"
              [hidden]="!holderLine.previousName"
            >{{ holderLine?.previousName || '' }}</div>

            @if (holderLine.areNamesDifferent) {
              <div
                class="new-name"
                [class]="{ green: holderLine.isNewName }"
              >{{ holderLine?.name || '-' }}</div>
            }

            @if (!holderLine.isIndividual) {
              <div class="color-gray-700 line-height-12">{{ (holderLine.entityNumber | acn) ?? '-' }}</div>
            }
          </li>
        }
      }
    </ul>
  </div>
</div>
